import {TypingEffect} from '../../modules/typingEffect.js';
import '../../components/cards/course.js';
import {SmoothAnchor} from '../../modules/smoothAnchor.js';

/** Initialize corporate page functionality */
function initPage() {
    new SmoothAnchor();
    
    // Find all typewriter instances and initialize them
    const placeholders = document.querySelectorAll('[data-typing-placeholder]');
    const pointsElements = document.querySelectorAll('[data-typing-points]');
    
    // Initialize typewriter for each pair found
    placeholders.forEach((placeholder, index) => {
        if (pointsElements[index]) {
            TypingEffect.animate(placeholder, pointsElements[index]);
        }
    });
}

document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initPage)
    : initPage();
